import React, { useState, useEffect } from "react"
import { Tag, Drawer, Descriptions, Spin, message, Badge } from "antd"
import { collection, query, where, getDocs, documentId } from "firebase/firestore"
import moment from "moment"
import { db } from "../../../../firebase/config"
import { OrderLocation } from "../../../../components/Orders/OrderLocation"

const InvoiceOrders = ({ orderReferenceIds }) => {
  const [orders, setOrders] = useState([])
  const [loading, setLoading] = useState(false)
  const [selectedOrder, setSelectedOrder] = useState(null)
  const [drawerVisible, setDrawerVisible] = useState(false)

  useEffect(() => {
    const fetchOrders = async () => {
      if (!orderReferenceIds || orderReferenceIds.length === 0) {
        setOrders([])
        return
      }
      setLoading(true)
      try {
        const ordersRef = collection(db, "orders")
        // Using Firestore's "in" query. (Up to 10 items)
        const q = query(ordersRef, where(documentId(), "in", orderReferenceIds))
        const querySnapshot = await getDocs(q)
        const fetchedOrders = []
        querySnapshot.forEach((docSnap) => {
          fetchedOrders.push({ id: docSnap.id, ...docSnap.data() })
        })
        setOrders(fetchedOrders)
      } catch (error) {
        message.error("Error fetching orders: " + error.message)
      } finally {
        setLoading(false)
      }
    }

    fetchOrders()
  }, [orderReferenceIds])

  const openDrawer = (order) => {
    setSelectedOrder(order)
    setDrawerVisible(true)
  }

  const closeDrawer = () => {
    setDrawerVisible(false)
    setSelectedOrder(null)
  }

  return (
    <div>
      {loading ? (
        <Spin />
      ) : orders.length === 0 ? (
        <p>No orders found.</p>
      ) : (
        orders.map((order) => (
          <Tag
            key={order.id}
            color="green"
            onClick={() => openDrawer(order)}
            style={{ cursor: "pointer", marginBottom: 8 }}>
            {order.orderNumber}
          </Tag>
        ))
      )}

      <Drawer
        title="Order Details"
        placement="right"
        onClose={closeDrawer}
        open={drawerVisible}
        width={400}>
        {selectedOrder && (
          <Descriptions column={1} bordered>
            <Descriptions.Item label="Order Number">
              {selectedOrder.orderNumber || "N/A"}
            </Descriptions.Item>
            <Descriptions.Item label="Location">
              <Badge status="processing" text={OrderLocation(selectedOrder.orderStatus || "N/A")} />
            </Descriptions.Item>
            <Descriptions.Item label="Client">
              {selectedOrder.client.client || "N/A"}
            </Descriptions.Item>
            <Descriptions.Item label="Product">
              {selectedOrder.selectedProduct?.product?.productName || "N/A"}
            </Descriptions.Item>
            <Descriptions.Item label="Material">
              {selectedOrder.selectedProduct?.material || "N/A"}
            </Descriptions.Item>
            <Descriptions.Item label="Weight">
              {typeof selectedOrder.weight === "number"
                ? `${selectedOrder.weight.toFixed(2)} kg`
                : selectedOrder.weight || "N/A"}
            </Descriptions.Item>
            <Descriptions.Item label="Created">
              {selectedOrder.created
                ? moment.unix(selectedOrder.created.seconds).format("DD/MM/YYYY HH:mm")
                : "N/A"}
            </Descriptions.Item>
          </Descriptions>
        )}
      </Drawer>
    </div>
  )
}

export default InvoiceOrders
